module.exports = __webpack_public_path__ + "img/user-2.ced61ffa.svg";